import React from 'react';
import markUrl from '../assets/tf-mark.png';

// TRUSTFRAME primary mark — published artwork from /TRUSTFRAME Logo.html.
// Asset is pure white pixels on transparent background; we use CSS filters
// to render it in any solid colour. Per brand guidelines: always flat,
// white on dark, black on light, never tinted.
//
// Colour switching technique:
//   - default (white): no filter
//   - color="black":   filter: invert(1)
//   - color="<hex>":   we synthesise a CSS filter that drops the white pixels
//                      onto the target colour by chaining brightness/sepia/etc.
//                      Easier approach: render as a mask-image which paints
//                      with currentColor. That is what we do here.

export function TFMark({ color = 'currentColor', size = 32, className = '', dataTestId = 'tf-mark', style = {} }) {
  return (
    <span
      role="img"
      aria-label="TrustFrame mark"
      data-testid={dataTestId}
      className={`inline-block flex-shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        WebkitMask: `url(${markUrl}) center / contain no-repeat`,
        mask: `url(${markUrl}) center / contain no-repeat`,
        ...style,
      }}
    />
  );
}

// Lockup: mark + wordmark, horizontal — wide-tracking per brand book
export function TFLogo({ color = 'currentColor', size = 28, className = '', wordmark = true, gap = 16 }) {
  return (
    <span className={`inline-flex items-center ${className}`} style={{ gap }}>
      <TFMark color={color} size={size} />
      {wordmark && (
        <span
          className="font-machina font-bold uppercase select-none"
          style={{ color, fontSize: size * 0.42, lineHeight: 1, letterSpacing: '0.75em', paddingLeft: '0.75em' }}
        >
          TRUSTFRAME
        </span>
      )}
    </span>
  );
}

// Monogram "T F" — used as compact lockup
export function TFMonogram({ color = 'currentColor', fontSize = 14, className = '' }) {
  return (
    <span
      className={`font-machina font-bold uppercase select-none ${className}`}
      style={{ color, fontSize, lineHeight: 1, letterSpacing: '1.2em', paddingLeft: '1.2em' }}
    >
      T F
    </span>
  );
}
